<template>
    <div v-loading.fullscreen.lock="state.loading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-page-header content="添加用户" :icon="null" title="用户管理" />
        <el-form ref="userFormRef" :model="state.formValue" :rules="state.formRules" label-width="80px"
            class="demo-ruleForm" status-icon>
            <el-form-item label="用户名" prop="userName">
                <el-input v-model="state.formValue.userName" placeholder="请输入用户名" />
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input v-model="state.formValue.password" type="password" placeholder="请输入密码" />
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
                <el-input v-model="state.formValue.phone" type="number" placeholder="请输入手机号" />
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
                <el-input v-model="state.formValue.email" type="text" placeholder="请输入邮箱" />
            </el-form-item>
            <el-form-item label="推荐人Id" prop="recommenderId">
                <el-input v-model="state.formValue.recommenderId" type="text" placeholder="请输入推荐人Id" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm()">
                    添加用户
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script setup>
import { reactive, ref } from "vue";
import { useRouter } from 'vue-router'
import { phoneValidator, emailValidator } from "@/util/formValidator";
import { userAddFun } from "@/api/user"

const router = useRouter();
const userFormRef = ref();
const state = reactive({
    formValue: {
        userName: '',
        password: '',
        phone: '',
        email: '',
        recommenderId: '',
        type: 1,// 1微信用户 2抖音用户 3管理员
    },
    formRules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        phone: [{ required: true, validator: phoneValidator, trigger: 'blur' }],
        email: [{ validator: emailValidator, trigger: 'blur' }],
    },
    loading: false,
});
const submitForm = () => {
    // 1.校验表单
    userFormRef.value.validate((valid) => {
        if (valid) {
            state.loading = true;
            userAddFun(state.formValue).then(res => {
                userFormRef.value.resetFields();
                router.push('/userManage/userList');
            }).finally(() => {
                state.loading = false;
            })
        }
    })
}
</script>
<style lang="scss" scoped>
.demo-ruleForm {
    margin-top: 50px;
}
</style>